import { LIGHT_YELLOW, LIGHT_RED } from '../../../utils';

export const styles = {
  cardcontent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  countryTxt: {
    color: 'white',
    justifyContent: 'center',
    paddingBlock: 'auto',
    alignSelf: 'center',
    fontWeight: '500',
    textTransform: 'uppercase',
  },
  countryTxtBox: {
    width: '95%',
    height: 45,
    alignItems: 'center',
    backgroundColor: '#212529',
    justifyContent: 'center',
    display: 'flex',
    marginBottom: 6,
  },
  flexBox: {
    display: 'flex',
    width: '100%',
    overflowX: 'auto',
    justifyContent: 'center',
    gap: 20,
    padding: '0 8px',
  },
  arrow: { marginTop: 2, height: 35, width: 35 },
  baggageTxt: {
    textAlign: 'center',
    backgroundColor: '#D3E1FC',
    borderColor: '#BCD3FA',
    borderWidth: 2,
    fontWeight: '500',
  },
  dateCardBox: {
    width: '100%',
    height: 55,
    marginBottom: 0,
    alignItems: 'center',
    backgroundColor: LIGHT_YELLOW,
    border: '1.5px solid #E08B32',
    borderRadius: 0,
    boxShadow: 'none',
    margin: 0,
  },
  resultCardBox: {
    width: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
    '&:hover': {
      // cursor: 'not-allowed',
      cursor: 'pointer',
    },
    margin: 0,
  },
  resultCardTop: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#D6D6D6',
    paddingInline: 5,
  },
  fullBox: {
    backgroundColor: LIGHT_RED,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  seatsTxt: {
    textAlign: 'center',
    backgroundColor: '#F3D8DA',
    fontWeight: 'bold',
  },
  economyTxt: {
    textAlign: 'center',
    fontWeight: 'bold',
    paddingInline: 10,
  },
  directBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  seatBox: {
    marginBlock: 5,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};
